/*
 * Keeps a locked companion line (battery eco-fee) in sync with every electric
 * bike in the cart. Rules come from the data attributes rendered by
 * snippets/cart-companion-attrs.liquid, so this only has to run after each
 * cart render and fix the differences.
 */
(() => {
  let lastSignature = '';
  let busy = false;
  let timer;

  const readLines = () =>
    [...document.querySelectorAll('.cart-item[data-key]')].map((el) => ({
      key: el.dataset.key,
      quantity: Number(el.dataset.quantity),
      companion: el.dataset.companion,
      companionOf: el.dataset.companionOf,
    }));

  const diff = (lines) => {
    const parents = lines.filter((line) => line.companion);
    const companions = lines.filter((line) => line.companionOf);
    const items = [];
    const updates = {};
    parents.forEach((parent) => {
      const companion = companions.find((line) => line.companionOf === parent.key);
      if (!companion) {
        items.push({ id: Number(parent.companion), quantity: parent.quantity, properties: { _companion_of: parent.key } });
      } else if (companion.quantity !== parent.quantity) {
        updates[companion.key] = parent.quantity;
      }
    });
    companions.forEach((companion) => {
      if (!parents.some((parent) => parent.key === companion.companionOf)) updates[companion.key] = 0;
    });
    return { items, updates };
  };

  const post = (url, body, sections) =>
    fetch(url, {
      ...fetchConfig(),
      body: JSON.stringify({ ...body, sections, sections_url: window.location.pathname }),
    }).then((response) => response.json());

  const itemsContainer = () =>
    document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');

  async function reconcile() {
    if (busy) return;
    const lines = readLines();
    const signature = lines.map((line) => `${line.key}:${line.quantity}`).join('|');
    if (signature === lastSignature) return;
    lastSignature = signature;

    const { items, updates } = diff(lines);
    const cartItems = document.querySelector('cart-items, cart-drawer-items');
    if (!cartItems || (!items.length && !Object.keys(updates).length)) return;

    busy = true;
    itemsContainer()?.classList.add('cart__items--disabled');
    try {
      const sections = cartItems.getSectionsToRender();
      const sectionIds = sections.map((section) => section.section);
      let state;
      if (Object.keys(updates).length) state = await post(routes.cart_update_url, { updates }, sectionIds);
      if (items.length) state = await post(routes.cart_add_url, { items }, sectionIds);
      if (state.status) throw new Error(state.description || state.message);

      sections.forEach((section) => {
        const wrapper = document.getElementById(section.id);
        const target = wrapper?.querySelector(section.selector) || wrapper;
        if (target && state.sections[section.section]) {
          target.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
        }
      });
      if (document.querySelector('.cart-shipping')) cartItems.cartShipping();
      if (state.item_count !== undefined) {
        ['cart-drawer', 'cart-items', '#main-cart-footer'].forEach((selector) =>
          document.querySelector(selector)?.classList.toggle('is-empty', state.item_count === 0)
        );
      }
    } catch (error) {
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = error.message || window.cartStrings.error;
    } finally {
      busy = false;
      itemsContainer()?.classList.remove('cart__items--disabled');
      schedule();
    }
  }

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 100);
  };

  const init = () => {
    document.querySelectorAll('#CartDrawer, #main-cart-items').forEach((root) => {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    });
    schedule();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
